import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconFlag = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--flag")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M3,3 C3,2.73478351 3.10535684,2.4804296 3.29289322,2.29289322 C3.51247012,2.07331631 3.90748509,1.809973 4.50360932,1.57152331 C5.40642491,1.21039707 6.56360882,1 8,1 C9.41656341,1 10.3826299,1.27601899 12.3713907,2.07152331 C14.1326299,2.77601899 14.9165634,3 16,3 C17.1886088,3 18.0939249,2.83539707 18.7536093,2.57152331 C19.0949851,2.434973 19.2624701,2.32331631 19.2928932,2.29289322 C19.9228581,1.66292836 21,2.10909515 21,3 L21,15 C21,15.2652165 20.8946432,15.5195704 20.7071068,15.7071068 C20.4875299,15.9266837 20.0925149,16.190027 19.4963907,16.4284767 C18.5935751,16.7896029 17.4363912,17 16,17 C14.5834366,17 13.6173701,16.723981 11.6286093,15.9284767 C9.86737011,15.223981 9.08343659,15 8,15 C6.81139118,15 5.90607509,15.1646029 5.24639068,15.4284767 C5.15049861,15.4668335 5.06832724,15.5032261 4.99906031,15.5364058 L5,22 C5,22.5522847 4.55228475,23 4,23 C3.44771525,23 3,22.5522847 3,22 L3,22 L3,3 Z M8,3 C6.81139118,3 5.90607509,3.16460293 5.24639068,3.42847669 C5.15093187,3.46666021 5.06907007,3.50289723 5,3.53595588 L5,13.396437 C5.81910645,13.1433287 6.8144511,13 8,13 C9.41656341,13 10.3826299,13.276019 12.3713907,14.0715233 C14.1326299,14.776019 14.9165634,15 16,15 C17.1886088,15 18.0939249,14.8353971 18.7536093,14.5715233 C18.8490681,14.5333398 18.9309299,14.4971028 19,14.4640441 L19,4.603563 C18.1808935,4.85667129 17.1855489,5 16,5 C14.5834366,5 13.6173701,4.72398101 11.6286093,3.92847669 C9.86737011,3.22398101 9.08343659,3 8,3 Z" id="icon--centivo--flag"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-369.000000, -636.000000)"/>
          <g id="Icon/flag">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--flag"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--flag"/>
          </g>
      </g>
  </IconWrapper>
)
